export const ULR_PATHS = {
    AUTO_LIVE_STREAM: 'customer/livestreamsettings',
    AUTO_REC_STREAM: 'customer/recordsettings',
    LIVESTREAM_USAGE_UPDATE: 'customer/saverecordings'
};
